import { render, staticRenderFns } from "./dataChart.vue?vue&type=template&id=4e794ed5&scoped=true&"
import script from "./dataChart.vue?vue&type=script&lang=js&"
export * from "./dataChart.vue?vue&type=script&lang=js&"
import style0 from "./dataChart.vue?vue&type=style&index=0&id=4e794ed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e794ed5",
  null
  
)

export default component.exports